import React, { useEffect } from 'react'
import { Link, useParams } from 'react-router-dom';
import Content from '../components/Content';
import DefaultLayout from '../components/DefaultLayout';
import SignUp from '../components/SignUp';

function Her({match}) {
  const city = useParams();
  useEffect(()=>{
    if (city.cityName === "SanAntonio")
    document.title ="San Antonio's Home for Women's Tantric & Yoni Massage | Mobile Body Therapy";
    else
    document.title = `${city.cityName}'s Home for Women's Tantric & Yoni Massage | Mobile Body Therapy`;
  },[]);
  return (
    <DefaultLayout city={city.cityName} userType="her">
    <Content userType="her" city={city.cityName}/>
    <SignUp userType="her"/>
    </DefaultLayout>
  )
}

export default Her